// Shared enum → French label maps for organization documents.
// Keys mirror the backend enums in app/models/organization_document.rb.

export const documentTypeLabels = ($gettext) => ({
  policy: $gettext("Politique"),
  procedure: $gettext("Procédure"),
  guide: $gettext("Guide"),
  document: $gettext("Document"),
  repository: $gettext("Référentiel"),
});

export const categoryLabels = ($gettext) => ({
  lbc_ft: $gettext("LBC-FT"),
  operations: $gettext("Opérations"),
  seller_risk_assessment: $gettext("Évaluation des risques vendeur"),
});

export const revisionFrequencyLabels = ($gettext) => ({
  every_6_months: $gettext("Tous les 6 mois"),
  annually: $gettext("Annuellement"),
  every_2_years: $gettext("Tous les 2 ans"),
  every_3_years: $gettext("Tous les 3 ans"),
  other: $gettext("Autre"),
});

export const toOptions = (labels) => Object.entries(labels).map(([value, label]) => ({ value, label }));
